import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d80a8b34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "merchant-day"
};
const _hoisted_2 = {
  class: "date-selector"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "index-txt"
};
const _hoisted_6 = {
  class: "info"
};
const _hoisted_7 = {
  class: "score-info"
};
const _hoisted_8 = {
  class: "des"
};
const _hoisted_9 = {
  class: "score-info"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "挖矿分", -1));
const _hoisted_11 = {
  key: 2,
  class: "me-first-info"
};
const _hoisted_12 = {
  key: 1,
  class: "index-txt"
};
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = {
  class: "score-info"
};
const _hoisted_15 = {
  class: "des"
};
const _hoisted_16 = {
  class: "score-info"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "挖矿分", -1));
import { onMounted, reactive, ref, nextTick } from "vue";
import { useRoute } from "vue-router";
import env from "md-base-tools/env";
import { getMinerRank, getMinerRankDate } from "@/api";
import { mdToast } from "../../utils/tools";
export default {
  setup(__props) {
    const route = useRoute();
    const dateListRef = ref(null); // 滚动容器的引用

    const state = reactive({
      record_status: -1,
      //-1全部 0待审核 10审核通过 20已结束 30已取消
      page: 1,
      page_size: 20,
      rankList: [],
      refreshing: false,
      is_next: true,
      loading: false,
      request_finished: false,
      user_rank_info: {},
      date_range: '',
      rankDateList: [],
      currentDateIndex: 0,
      // 添加当前选中的日期索引
      currentDateWeek: '',
      // 添加当前选中的日期周数
      dateItemRefs: [] // 存储每个日期项的DOM引用
    });
    onMounted(async () => {
      state.is_ip = route.query.is_ip == 1 ? true : false;

      //请求往期周数据
      await requestRankDate();

      // 等待DOM更新后居中第一个选中项
      nextTick(() => {
        centerSelectedItem(state.currentDateIndex);
      });

      // 如果是APP端，设置状态栏颜色&获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: '1'
          }
        });

        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "onGetDeviceInfo",
          functionParams: {},
          callBack: e => {
            state.statusBarH = e.data.statusBarH;
          }
        });
      }
    });
    async function requestRankDate() {
      const {
        status,
        data,
        message
      } = await getMinerRankDate();
      state.request_finished = true;
      if (status == 0 && data && data.length > 0) {
        state.rankDateList = data.reverse();
        state.currentDateWeek = data[0].week;

        //请求排行榜数据
        requestRankList();
      } else if (status !== 0) {
        mdToast(message || '获取数据失败');
      }
    }

    // 下拉刷新
    async function onRefresh() {
      state.page = 1;
      state.loading = true;
      await requestRankList();
    }

    // 上拉加载
    async function onLoadMore() {
      await requestRankList();
    }
    async function requestRankList() {
      const {
        status,
        data,
        message
      } = await getMinerRank({
        page: state.page,
        page_size: state.page_size,
        week: state.currentDateWeek
      });
      state.loading = false;
      state.refreshing = false;
      state.request_finished = true;
      if (status == 0) {
        if (state.page == 1) {
          state.rankList.splice(0, state.rankList.length);

          //用户排名信息
          if (data.login_user_rank && data.login_user_rank.user_id) {
            state.user_rank_info = data.login_user_rank;
          }

          //当前排名周范围
          if (data.date_range) {
            state.date_range = data.date_range;
          }
        }
        if (data.list && data.list.length > 0) {
          state.rankList.push(...data.list);
          state.page++;
          state.is_next = data.is_next;
        }
      } else {
        mdToast(message);
      }
    }
    function statusNameStyle(medal_level) {
      //1菜鸟 2资深 3精英 4达人 5传奇

      let style = {
        'color': '#FFFFFF',
        'background': '#F2F2F2'
      };
      switch (medal_level) {
        case 5:
          style = {
            'color': '#FFFFFF',
            'background': '#FFD769'
          };
          break;
        case 2:
          style = {
            'color': '#FFFFFF',
            'background': '#C78CFF'
          };
          break;
        case 3:
          style = {
            'color': '#FFFFFF',
            'background': '#00C4A1'
          };
          break;
        case 4:
          style = {
            'color': '#FFFFFF',
            'background': '#69C8FF'
          };
          break;
        case 1:
          style = {
            'color': '#333333',
            'background': '#F2F2F2'
          };
          break;
        default:
          break;
      }
      return style;
    }

    // 日期选择处理
    const handleDateSelect = async (index, item) => {
      if (state.currentDateIndex !== index) {
        state.currentDateIndex = index;
        state.currentDateWeek = item.week;
        state.rankList = [];

        // 等待DOM更新后滚动到中心位置
        nextTick(() => {
          centerSelectedItem(index);
        });
        onRefresh();
      }
    };

    // 将选中项滚动到居中位置
    const centerSelectedItem = index => {
      if (!dateListRef.value || !state.dateItemRefs[index]) return;
      const container = dateListRef.value;
      const selectedItem = state.dateItemRefs[index];

      // 计算目标滚动位置
      const containerRect = container.getBoundingClientRect();
      const itemRect = selectedItem.getBoundingClientRect();

      // 滚动到使选定项目居中的位置
      const scrollLeft = itemRect.left - containerRect.left - containerRect.width / 2 + itemRect.width / 2;

      // 使用平滑滚动效果
      container.scrollTo({
        left: container.scrollLeft + scrollLeft,
        behavior: 'smooth'
      });
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      const _component_Error = _resolveComponent("Error");
      return _unref(state).rankList.length > 0 || _unref(state).rankDateList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "date-list",
        ref_key: "dateListRef",
        ref: dateListRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).rankDateList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['date-item', {
            active: _unref(state).currentDateIndex === index
          }]),
          onClick: $event => handleDateSelect(index, item),
          ref_for: true,
          ref: el => {
            if (el) _unref(state).dateItemRefs[index] = el;
          }
        }, _toDisplayString(item.date_range), 11, _hoisted_3);
      }), 128))], 512)]), _unref(state).rankList.length > 0 ? (_openBlock(), _createBlock(_component_van_pull_refresh, {
        key: 0,
        modelValue: _unref(state).refreshing,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(state).refreshing = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_createVNode(_component_van_list, {
          class: "list",
          loading: _unref(state).loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = $event => _unref(state).loading = $event),
          finished: !_unref(state).is_next,
          "immediate-check": false,
          onLoad: onLoadMore
        }, {
          default: _withCtx(() => [_unref(state).user_rank_info && _unref(state).user_rank_info.user_id ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["list-card is_me", {
              'is_me_first': _unref(state).user_rank_info.rank == 1
            }])
          }, [_unref(state).user_rank_info.rank > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("img", {
            class: "me-img",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/miner/miner_rank_my_turn.png', 112)
          }, null, 8, _hoisted_4), _ctx.rank <= 3 ? (_openBlock(), _createBlock(_component_van_image, {
            key: 0,
            class: "index-icon",
            src: _ctx.$imgUrlFilter(`https://p6.moimg.net/mdwxapp/miner/miner_rank_0${_ctx.rank}.png`, 48)
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(state).user_rank_info.rank), 1))], 64)) : (_openBlock(), _createBlock(_component_van_image, {
            key: 1,
            class: "index-icon",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/miner/miner_none_rank.png', 48)
          }, null, 8, ["src"])), _createVNode(_component_van_image, {
            class: "icon",
            src: _ctx.$imgUrlFilter(_unref(state).user_rank_info.icon, 80)
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(_unref(state).user_rank_info.nick_name) + " ", 1), _createElementVNode("div", {
            class: "des",
            style: _normalizeStyle(statusNameStyle(_unref(state).user_rank_info.medal_level))
          }, _toDisplayString(_unref(state).user_rank_info.medal), 5)]), _createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString(_unref(state).user_rank_info.prize) + " ", 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(state).user_rank_info.prize_desc), 1)]), _createElementVNode("div", _hoisted_9, [_createTextVNode(_toDisplayString(_unref(state).user_rank_info.score) + " ", 1), _hoisted_10]), _unref(state).user_rank_info.rank == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, "站外宣发条件:目标达成且筹资≥10w")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).rankList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "list-card",
              key: index
            }, [index < 3 ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "index-icon",
              src: _ctx.$imgUrlFilter(`https://p6.moimg.net/mdwxapp/miner/miner_rank_0${index + 1}.png`, 48)
            }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(index + 1), 1)), _createVNode(_component_van_image, {
              class: "icon",
              src: _ctx.$imgUrlFilter(item.icon, 80)
            }, null, 8, ["src"]), _createElementVNode("div", _hoisted_13, [_createTextVNode(_toDisplayString(item.nick_name) + " ", 1), _createElementVNode("div", {
              class: "des",
              style: _normalizeStyle(statusNameStyle(item.medal_level))
            }, _toDisplayString(item.medal), 5)]), _createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString(item.prize) + " ", 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.prize_desc), 1)]), _createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(item.score) + " ", 1), _hoisted_17])]);
          }), 128))]),
          _: 1
        }, 8, ["loading", "finished"])]),
        _: 1
      }, 8, ["modelValue"])) : _unref(state).request_finished ? (_openBlock(), _createBlock(_component_Error, {
        key: 1,
        style: {
          height: '100%'
        },
        message: "什么都没有哦",
        class: "empty-box"
      })) : _createCommentVNode("", true)])) : _unref(state).request_finished ? (_openBlock(), _createBlock(_component_Error, {
        key: 1,
        style: {
          height: '100vh'
        },
        message: "还没有往期数据",
        class: "empty-box"
      })) : _createCommentVNode("", true);
    };
  }
};